module.exports = __webpack_public_path__ + "static/muteaudio-9ba39ed3888c54d8d8111d34ac47070f.png";